'use strict';

const headerMenuAisle = {
    retrieveAndDisplayAisle: function ($aisleId) {
        if (typeof retrieveAisleUrl !== 'undefined') {
            $.ajax({
                type: "GET",
                url: retrieveAisleUrl,
                data: {'aisleId': $aisleId},
                contentType: 'application/json',
                success: function (responseData) {
                    headerMenuAisle.displayBurgerMenuAisle(responseData);
                },
                error: function (jqXHR) {
                    TINK.redirectIfConflict(jqXHR);
                }
            });
        }
    },

    displayBurgerMenuAisle: function (currentAisle) {
        $('.aisles--subNav--lev2').empty();
        $('.aisles--subNav--lev3').empty();

        let $aisleSectionTitle = $('<h2 />').append(currentAisle.name);
        let $listUl = $('<ul />');
        let $stickyMainCategory = $('<div />', {'class': 'aisles-all-link '});
        let $linkMainCategory = $('<a />', {'href': baseShopOnlineUrl + currentAisle.url}).append(viewAllAislesCategory + ' ' + currentAisle.name);

        $stickyMainCategory.append($linkMainCategory);

        for(childAisle of currentAisle.children) {
            let $listChildLi;
            if (childAisle.children.length > 0) {
                $listChildLi = $('<li />', {'class': 'aisle-lvl-two'});
                let $btnOpenGrandChild = $('<button />', {'role': 'button',
                    'class': 'btn-display--sub-nav dataLayerBigMenuLevelTwo',
                    'type': 'button',
                    'data-ga-id': 'top-nav-level1',
                    'data-menu-name': 'Aisles',
                    'aria-expanded': 'false',
                    'data-sub-nav-id': 'subNav--id--'+childAisle.id,
                    'data-sub-menu-name': currentAisle.name,
                    'data-child-menu-name': childAisle.name});
                let $spanOpenChild = $('<span>'+ childAisle.name +'</span>');
                let $titleGrandChild = $('<h2 />', {'class': 'subNav--id--'+childAisle.id}).append(childAisle.name);
                let $listGrandChildUl = $('<ul />', {'class': 'subNav--id--'+childAisle.id});
                let $stickyAllLink = $('<div>', {'class': 'aisles-all-link subNav--id--'+childAisle.id});
                let $btnAllLink = $('<a>', {'href': baseShopOnlineUrl + childAisle.url}).append(viewAllAislesCategory + ' ' + childAisle.name);


                for(grandChildAisle of childAisle.children) {
                    let $listGrandChildLi = $('<li />');
                    let $linkGrandChilMainCategory = $('<a />', {'href': baseShopOnlineUrl + grandChildAisle.url,
                        'class': ' dataLayerBigMenuLevelFour',
                        'data-menu-name': 'Aisles',
                        'data-sub-menu-name': currentAisle.name,
                        'data-child-menu-name': childAisle.name,
                        'data-grand-child-menu-name': grandChildAisle.name});
                    $linkGrandChilMainCategory.append('<span>'+grandChildAisle.name+'</span>');
                    $listGrandChildLi.append($linkGrandChilMainCategory);
                    $listGrandChildUl.append($listGrandChildLi);
                }

                $stickyAllLink.append($btnAllLink);

                if (Revealizr.isDesktopSize) {
                    $('.aisles--subNav--lev3').append($stickyAllLink, $listGrandChildUl);
                } else {
                    $('.aisles--subNav--lev3').append($titleGrandChild, $listGrandChildUl, $stickyAllLink);
                }

                $btnOpenGrandChild.append($spanOpenChild);
                $listChildLi.append($btnOpenGrandChild);
            } else {
                $listChildLi = $('<li />', {'class': 'li-no-child aisle-lvl-two'});
                let $linkChildMainCategory = $('<a />', {'href': baseShopOnlineUrl + childAisle.url});
                $linkChildMainCategory.append('<span>'+childAisle.name+'</span>');

                $listChildLi.append($linkChildMainCategory);
            }

            $listUl.append($listChildLi);

        }


        if (Revealizr.isDesktopSize) {
            $('.aisles--subNav--lev2').append($stickyMainCategory, $listUl);
            let lastChildActiveNav = $('.sub--nav--second.active--nav').find('li').last();
            headerMenuAisle.aisleMenuFocusTrap(lastChildActiveNav);
            $('.aisles--subNav--lev2 .aisles-all-link a').focus();
        } else {
            $('.aisles--subNav--lev2').append($aisleSectionTitle, $listUl, $stickyMainCategory);
        }

        // MANAGE LEVEL 3 DISPLAY
        $('.btn-display--sub-nav').click(function () {
            let activeGrandChild = $(this).data('sub-nav-id');
            $('.btn-display--sub-nav').attr('aria-expanded', false);
            $('.active--sub-nav').removeClass('active--sub-nav');
            $('.sub--nav--third').addClass('active--nav');
            $('.sub-nav-head').addClass('three-col');
            $('.' + activeGrandChild).addClass('active--sub-nav');
            $(this).attr('aria-expanded', true);

            if (!Revealizr.isDesktopSize) {
                $('.sub--nav--second').addClass('hide-overflow');
            } else {
                setTimeout(function () {
                    $('.aisles-all-link.active--sub-nav a').focus();
                }, 100);
                let lastChildActiveNav = $('ul.active--sub-nav li').last();
                headerMenuAisle.aisleMenuFocusTrap(lastChildActiveNav);
            }
        });
    },

    // ACCESSIBILITÉ
    aisleMenuFocusTrap: function (elm) {
        let $isSubNavActive;
        let lastElm = elm.children();
        lastElm.on('keydown', function (e) {
            if ($('this:focus') && (!e.shiftKey && e.keyCode === 9)) {
                e.preventDefault();
                $isSubNavActive = $('.sub--nav--second.active--nav');
                if ($isSubNavActive.length) {
                    let $focusedElement = $(':focus');
                    let focusInSubAisles = $focusedElement.parentsUntil('.active--nav').length;
                    if (focusInSubAisles) {
                        $('.navigation__btn--close').focus();
                    } else {
                        $isSubNavActive.find('.aisles-all-link a').focus();
                    }
                } else {
                    $('.navigation__btn--close').focus();
                }
            }
        });

        $('.navigation__btn--close').on('keydown', function (e) {
            if ($('this:focus') && (e.shiftKey && e.keyCode === 9)) {
                e.preventDefault();
                lastElm.focus();
            }
        });
    },
}

jQuery(document).ready(function() {
    $('.btn-display-aisle').click(function () {
        let activeStatus = $(this).attr('aria-expanded');
        let subAisleImage= $(this).data('sub-nav-image');

        if (activeStatus === 'false') {
            $('.btn-display-aisle').attr('aria-expanded', false);
            headerMenuAisle.retrieveAndDisplayAisle($(this).attr('data-aisle'));
            $('.sub--nav--third').removeClass('active--nav');
            $('.sub--nav--second').addClass('active--nav');
            $('.sub-nav-head').removeClass('three-col');
            $('.sub-nav-head').addClass('two-col');
            $(this).attr('aria-expanded', true);
            if (!Revealizr.isDesktopSize) {
                $('.sub--nav--first').addClass('hide-overflow');

                if (subAisleImage) {
                    $('.aisles-deco-image').css('background-image', 'url(' + subAisleImage + ')');
                } else {
                    $('.aisles-deco-image').css('background-image', 'url()');
                }
            }
        }
    });
});